export const TABLE_UPDATE = "PRINT_PRINTERS/TABLE_UPDATE";
export const FETCH_SUCCESS = "PRINT_PRINTERS/FETCH_SUCCESS";

const types = {
    FETCH_FAILED: "PRINT_PRINTERS/FETCH_FAILED",
    FETCH_REQUEST: "PRINT_PRINTERS/FETCH_REQUEST",
    FETCH_SUCCESS,

    GET_FAILED: "PRINT_PRINTERS/GET_FAILED",
    GET_REQUEST: "PRINT_PRINTERS/GET_REQUEST",
    GET_SUCCESS: "PRINT_PRINTERS/GET_SUCCESS",

    TABLE_UPDATE,
};

export default types;
